import { DEV_BASE_URL } from "../constants";
import api from './api';

export async function requestOtp(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/agent/login";
        let userData = {
            "email": data['email']
        }

        const res = await api.post(url, userData);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error)
    }
}

export async function verify_login(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/agent/verify_login";
        let userData = {
            "email": data['email'],
            "otp": data['otp']
        }

        const res = await api.post(url, userData);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function lead_insert(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/leads/insert";

        const res = await api.post(url, data);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function getLeads(params = "") {
    try {
      let url = DEV_BASE_URL + "oauth/leads/agent/leads";
  
      if (typeof params === "object" && params !== null) {
        const queryString = new URLSearchParams(params).toString();
        if (queryString) {
          url += `?${queryString}`;
        }
      } 
      else if (typeof params === "string" && params.trim().length > 0) {
        url += params.startsWith("?") ? params : `?${params}`;
      }
  
      const res = await api.get(url);
      const data = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
  
      return data;
    } catch (error) {
      console.error("Error fetching leads:", error);
      return { status: false, data: [] };
    }
}   

export async function getAgentLeads(user_id) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/agent/specific/leads?user_id="+user_id;
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error;
    }
}

export async function searchLeads(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/leads/search?query="+data['query']+"&type="+data['type'];
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error;
    }
}

export async function searchUser(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/users/search/?query="+data['query']+"&type="+data['type'];
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error;
    }
}

export async function getLeadDetails(leadId) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/leads/history?lead_id="+leadId;
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error; 
    }
}

export async function getUsers(query) {
    try {
        const params = new URLSearchParams(query);
        let url = DEV_BASE_URL + "oauth/leads/agents?"+params.toString();
        const res = await api.get(url);
        
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error; 
    }
}

export async function getUserDetails(query) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/user";
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error; 
    }
}

export async function fetchAgentReports(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/agent/reports";
        
        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error; 
    }
}

export async function updateUserDetails(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/user/";
        const userData = {
                "user_id": data['user_id'],
                "name": data['name'],
                "email": data['email'],
                "mobile": data['mobile'],
                "on_a_break": data['on_a_break'],
                "user_type": data['user_type'],
                "bucket": data['bucket'],
                "is_active": data['is_active'],
                "is_blocked": data['is_blocked']
        };

        const res = await api.post(url, userData);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function getBuckets(query) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/buckets?"+query;
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error; 
    }
}

export async function update_bucket(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/buckets/update";
        let userData = {
            "bucket_id": data['bucket_id'],
            "data": data['update_data']
        }

        const res = await api.post(url, userData);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function update_agent(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/agent/update";
        let userData = {
            "user_id": data['user_id'],
            "data": data['update_data']
        }

        const res = await api.post(url, userData);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function getLeadConfig(types) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/settings?type="+types;
        const res = await api.get(url);
        return res['data'];
    } catch (error) {
        console.log('There was an error in fetching the leads: ', error);
        return error; 
    }
}

export async function setLeadConfig(type, update_data, isEditing = false) {
    try {
      let url = DEV_BASE_URL + "oauth/leads/settings";
      let data = {
        type: type,
        data: update_data,
      };

      const method = isEditing ? "put" : "post";
  
      const res = await api[method](url, data);
      return res["data"];
    } catch (error) {
      console.log("There was an error in setLeadConfig:", error);
      return { status: false, error };
    }
  }
  

export async function updateLead(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/leads/update";
        const res = await api.post(url, data);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function addUser(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/agents/add";

        const res = await api.post(url, data);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function importLeads(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/import";

        const res = await api.post(url, data);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export async function transferLeads(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/transfer";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}

export async function deleteLeads(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/delete";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}

export async function deleteLeadConfig(type, id) {
    try {
      const url = DEV_BASE_URL + "oauth/leads/settings";
      const res = await api.delete(url, { data: { "type": type, "id": id } });
      return res["data"];
    } catch (error) {
      console.log("There was an error in deleteLeadConfig:", error);
      return { status: false, error };
    }
  }

export async function call_p2p(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/click_to_call";

        const res = await api.post(url, data);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error);
        return error;
    }
}

export const getFollowups = async (user_type) => {
    try{
        let url = DEV_BASE_URL + "oauth/leads/followups?type="+user_type;
        const res = await api.get(url);
        return res["data"];
    } catch (error) {
        console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function deleteFollowUp(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/followups";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}

export async function fetchExamsAdmin() {
    try{
        let url = DEV_BASE_URL + "oauth/leads/test_list";
        const res = await api.get(url);
        return res["data"];
    } catch (error) {
        console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function importTestData(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/test/import";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}

export async function createNewTest(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/test/create";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}

export async function updateTest(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/test/update";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}

export async function resetTest(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/test/reset";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}

export async function sendTestReports(data) {
    try {
        let url = DEV_BASE_URL + "oauth/leads/test/send_reports";

        const res = await api.post(url, data);
        return res['data'];
    } catch (error) {
        console.log('There was an error in transferring leads:', error);
        return error;
    }
}